export const asString = (value: unknown, fallback = ''): string =>
  typeof value === 'string' ? value : fallback;

export const asNumber = (value: unknown, fallback = 0): number =>
  typeof value === 'number' && Number.isFinite(value) ? value : fallback;

export const asBoolean = (value: unknown, fallback = false): boolean =>
  typeof value === 'boolean' ? value : fallback;

export const asStringArray = (value: unknown): string[] =>
  Array.isArray(value) ? value.filter((item): item is string => typeof item === 'string') : [];

export const asRecord = (value: unknown): Record<string, unknown> =>
  value !== null && typeof value === 'object' ? (value as Record<string, unknown>) : {};

export const asRecordArray = (value: unknown): Record<string, unknown>[] =>
  Array.isArray(value) ? value.map(asRecord) : [];

/**
 * Only explicit manualConfirmation stays manual-only. Legacy movement/activity
 * and unknown values resolve to either so workers keep a confirm-safe path.
 */
export const resolveEmergencySafetyCheckSatisfactionMode = (
  value: unknown,
): 'manualConfirmation' | 'either' =>
  value === 'manualConfirmation' ? 'manualConfirmation' : 'either';
